import axios from 'axios';
import { FRESH_CUSTOMER_URL } from './constants';

import { serviceFreshErrorCallback } from '../callbacks';

export function isEligibleBusiness() {
  return axios.get(FRESH_CUSTOMER_URL).catch(serviceFreshErrorCallback);
}
